export default [
    {
        name: 'topBanner',
        type: 'texture',
        path: 'textures/topBanner.jpg'
    },
    {
        name: 'bottomBanner',
        type: 'texture',
        path: 'textures/bottomBanner.jpg'
    },
    {
        name: 'profilePic',
        type: 'texture',
        path: 'textures/me.png'
    },
    {
        name: 'swirl',
        type: 'gltfModel',
        path: 'models/swirl.glb'
    }
]